<template>
    <div class="logo_title"
        :style="isUnfold ? { width: '216px', padding: '11px 24px' } : { padding: '11px 0px 11px 24px' }">
        <div class="logo">
            <img src="@/assets/image/logo.png" alt="logo" class="image" @click="onClickLogo">
        </div>
        <!-- <div class="versions">
            <span>2.0.1</span>
        </div> -->
    </div>
</template>

<script>
import { ref } from 'vue';

export default {
    data() {
        const isUnfold = ref(true);

        const onClickLogo = () => {
            const identity = localStorage.getItem('user_login_identity');
            if (identity == 'cx' && location.pathname != '/toBeDone') window.open('/toBeDone');
            else window.open('/business/cstomer');
        };

        return {
            isUnfold,
            onClickLogo
        }
    }
}
</script>
<style lang="scss">
.logo_title {
    height: 56px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 11px 24px;

    .logo {
        .image {
            width: 66px;
            height: auto;
            cursor: pointer;
        }
    }

    .title {
        font-size: 16px;
        font-weight: 500;
        margin: 0 5px;
    }

    .versions {
        width: 60px;
        height: 20px;
        background: #F5F5F5;
        border-radius: 12px 26px 26px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 12px;
        color: #919398;
        margin-left: 5px;
    }
}
</style>